import { render, staticRenderFns } from "./OrganismBackupManagement.vue?vue&type=template&id=62f5fb66&scoped=true&"
import script from "./OrganismBackupManagement.vue?vue&type=script&lang=js&"
export * from "./OrganismBackupManagement.vue?vue&type=script&lang=js&"
import style0 from "./OrganismBackupManagement.vue?vue&type=style&index=0&id=62f5fb66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f5fb66",
  null
  
)

export default component.exports